import { v4 as uuidv4 } from '@lukeed/uuid'
import { ArgumentNullError } from '../ArgumentNullError'
import { globalState } from '../globalState'
import { encodeGnip } from '../types/models'
import { IStore } from '../types/store'

export const createSessionId = () => uuidv4()

export const getTokenAndLanguage = (store: IStore) => {
    const { playerId, token, zoneId, language } = store
    if (!playerId) {
        throw new ArgumentNullError('playerId', playerId)
    }
    return {
        token,
        zoneId,
        locale: language,
        ping: encodeGnip({ ...store, playerId }),
    }
}

export const getPing = (): string => {
    const store = globalState.getStore()
    const { playerId } = store
    if (!playerId) {
        throw new ArgumentNullError('playerId', playerId)
    }
    return encodeGnip({ ...store, playerId })
}
